//#region src/modules/Files/utils/resolve-file-name.ts
/**
* Derives a downloaded file's name from its S3 response.
*
* S3 publishes the original filename in user metadata rather than
* `Content-Disposition`, so without this a download is named from the url
* basename — ie. the object key `6255fb01de555031049d837b.docx` instead of
* `Destiny Patrol Screenshots.docx`. Both headers are listed in the bucket's
* `Access-Control-Expose-Headers`, so they are readable cross-origin.
*
* Returning null falls back to atalaya's default resolution.
*/
var resolveFileName = (response) => response.headers.get("x-amz-meta-filename") || response.headers.get("x-amz-meta-name");
//#endregion
export { resolveFileName };

//# sourceMappingURL=resolve-file-name.js.map